module.exports = __webpack_public_path__ + "static/media/banner-wap.ae41dba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/banner-wap.png
// module id = 647
// module chunks = 0